import React from 'react';
import LeaderboardView from '../../../common/components/gamification/LeaderboardView';

const UserLeaderboardPage = () => (
  <LeaderboardView
    title="Leaderboard"
    subtitle="View rankings and compare your learning progress with others"
    iconClass="fas fa-trophy"
    variant="user"
  />
);

export default UserLeaderboardPage;
